import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

/** How long the non-blocking game alert stays visible after a game opens */
const DISPLAY_MS = 10_000

const ALERT_Z = 100_000

export type GameAlertBannerProps = {
  /** When this becomes truthy (game launching), the alert shows for {@link DISPLAY_MS} then hides. Game keeps running. */
  gamePlay: unknown
}

/**
 * "Game Alert" — 100 Points = 1 Point in Casino Games.
 * Renders above the casino iframe; pointer-events: none so it does not block play or EXIT.
 */
const GameAlertBanner: React.FC<GameAlertBannerProps> = ({ gamePlay }) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!gamePlay) {
      setVisible(false)
      return
    }
    setVisible(true)
    const t = window.setTimeout(() => setVisible(false), DISPLAY_MS)
    return () => window.clearTimeout(t)
  }, [gamePlay])

  if (!visible) return null

  return createPortal(
    <div
      style={{
        position: 'fixed',
        top: 12,
        left: 12,
        right: 12,
        zIndex: ALERT_Z,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
      }}
      aria-live='polite'
    >
      <div
        role='status'
        style={{
          pointerEvents: 'none',
          maxWidth: 520,
          width: '100%',
          background: 'linear-gradient(145deg, #152a2e 0%, #0b1719 100%)',
          border: '1px solid rgba(251, 191, 36, 0.5)',
          borderRadius: 12,
          padding: '14px 20px',
          boxShadow: '0 12px 40px rgba(0,0,0,0.5)',
        }}
      >
        <div
          style={{
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: '#fbbf24',
            marginBottom: 8,
          }}
        >
          Game Alert
        </div>
        <div style={{ fontSize: 16, color: '#f4f4f5', lineHeight: 1.5, fontWeight: 600 }}>
          10 Rs = 1 Point in Casino Games
        </div>
      </div>
    </div>,
    document.body
  )
}

export default GameAlertBanner
